import { useMemo } from 'react';
import {
  RadarChart,
  Radar,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis,
  ResponsiveContainer,
  Tooltip,
} from 'recharts';
import { chartColors } from './chartColors';

interface CategoryRadarProps {
  data: Record<string, number>;
}

export function CategoryRadar({ data }: CategoryRadarProps) {
  const chartData = useMemo(
    () =>
      Object.entries(data).map(([key, value]) => {
        const label = key.replace(/_score$/, '');
        return {
          category: label.charAt(0).toUpperCase() + label.slice(1),
          score: value,
        };
      }),
    [data]
  );

  if (chartData.length === 0) {
    return null;
  }

  return (
    <ResponsiveContainer width="100%" height={300}>
      <RadarChart data={chartData}>
        <PolarGrid />
        <PolarAngleAxis dataKey="category" fontSize={12} />
        <PolarRadiusAxis domain={[0, 5]} tickCount={6} fontSize={10} />
        <Tooltip />
        <Radar
          dataKey="score"
          stroke={chartColors.series}
          fill={chartColors.series}
          fillOpacity={chartColors.fillOpacity}
        />
      </RadarChart>
    </ResponsiveContainer>
  );
}
